module.exports = __webpack_public_path__ + "img/icon-6.73ba0cc2.png";